<script lang="ts" setup>
export type InsuranceIcon = {
    path: string
}
export interface InsuranceServicesIconProps {
    icon: ImageSimple
}

const props = defineProps<InsuranceServicesIconProps>()
</script>
<template>
  <IconImg
    :src="props.icon.path"
    :size="22"
    class="insurance-services-icon d-block flex-shrink-0 me-3 text-secondary"
  />
</template>

<style lang="scss" scoped>
@import './WidgetInsuranceServices.scss';
</style>
